<template>
  <div
    class="flex flex-col md:flex-row gap-base items-center justify-between px-lg py-twenty rounded-10 border-2 border-solid border-secondaryHover"
  >
    <div class="flex items-center gap-base">
      <InfoIndicator size="xLarge" />
      <p class="text-16 text-black" data-test="text">
        <slot name="text"></slot>
      </p>
    </div>

    <div data-test="action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import InfoIndicator from '@/components/library/indicators/InfoIndicator.vue';

export default defineComponent({
  components: {
    InfoIndicator,
  },
});
</script>
